import { toMoneyString } from "../Money";
import { isBlank } from "../../lib/presence";

export const trackDonationLevelChangeWithGTag = ({ donationLevel, prevDonationLevel }) => {
  if (isBlank(prevDonationLevel) || prevDonationLevel.level === donationLevel.level) {
    return;
  }

  window?.gtag('event', 'donation_level_change', {
    event_category: "sweepstakes",
    currency: "USD",
    value: donationLevel.price / 100,
    level: donationLevel.level,
    previous_level: prevDonationLevel.level,
    previous_level_price: prevDonationLevel.price / 100,
    change_direction: donationLevel.price > prevDonationLevel.price ? 'increase' : 'decrease',
  });
}

const trackDonationBeganWithGTag = ({ paymentIntent, donationLevel, promoCode }) => {
  window?.gtag('event', 'donation_began', {
    event_category: 'sweepstakes',
    event_label: 'donation',
    currency: paymentIntent.currency,
    value: toMoneyString({ cents: paymentIntent.amount, format: '0.00'}),
    transaction_id: paymentIntent.id,
    coupon: promoCode && promoCode.name,
    items: [
      {
        item_id: donationLevel.id,
        item_name: `${toMoneyString({ cents: paymentIntent.amount })} Donation`,
      }
    ],
  });
};

const trackPurchaseWithGTag = ({ paymentIntent, paymentMethod, donationLevel, promoCode }) => {
  window?.gtag('event', 'purchase', {
    event_category: 'sweepstakes',
    event_label: 'donation',
    currency: paymentIntent.currency,
    value: toMoneyString({ cents: paymentIntent.amount, format: '0.00'}),
    transaction_id: paymentIntent.id,
    coupon: promoCode && promoCode.name,
    payment_type: paymentMethod || 'card',
    items: [
      {
        item_id: donationLevel.id,
        item_name: `${toMoneyString({ cents: paymentIntent.amount })} Donation`,
      }
    ],
  });
};

const trackPurchaseWithGoogleAds = ({ paymentIntent, sweepstakes }) => {
  if(sweepstakes.googleAdsConversionId) {
    window?.gtag('event', 'conversion', {
      send_to: sweepstakes.googleAdsConversionId,
      value: toMoneyString({ cents: paymentIntent.amount, format: '0.00'}),
      currency: paymentIntent.currency,
      transaction_id: paymentIntent.id,
    });
  }
};

const trackPurchaseWithFacebook = ({ paymentIntent, donationLevel }) => {
  window?.fbq('track', 'Purchase', {
    value: toMoneyString({ cents: paymentIntent.amount, format: '0.00'}),
    currency: paymentIntent.currency,
    content_ids: [donationLevel.id],
  });
};

export const trackDonationBegan = (data) => {
  trackDonationBeganWithGTag(data);
}

export const trackPurchase = (data) => {
  trackPurchaseWithGTag(data);
  trackPurchaseWithGoogleAds(data);
  trackPurchaseWithFacebook(data);
};
